import { IOrderWizardService } from '../contracts/order-wizard.service.contract';
import { IPerson } from '../contracts/person.model.contract';
import { ProductCategory } from 'app/+core/common/model/product-category.model';
import { Product } from 'app/+core/common/model/product.model';

export class OrderWizardService implements IOrderWizardService {
  private _selectedPerson: IPerson;
  private _selectedProductCategory: ProductCategory;
  private _selectedProduct: Product;  

  get selectedPerson(): IPerson {
    return this._selectedPerson;
  }
  get selectedProductCategory(): ProductCategory {
    return this._selectedProductCategory;
  }
  get selectedProduct(): Product {
    return this._selectedProduct;
  }

  set selectedPerson(v) {
    this._selectedPerson = v;
  }
  set selectedProductCategory(v) {
    this._selectedProductCategory = v;
  }
  set selectedProduct(v) {
    this._selectedProduct = v;
  }
}



// WEBPACK FOOTER //
// ./src/app/+common/services/order-wizard.service.ts